
<template>
  <!--敏感词管理-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="chat_sensitive_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>

    <!--修改敏感词的弹窗-->
    <a-modal
      title="修改敏感词"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      centered
      :maskClosable="false"
      :keyboard="false"
      destroyOnClose
    >
      <a-form :form="modalForm">
        <a-form-item label="敏感词" v-bind="$store.state.modal_ItemLayout">
          <a-input v-decorator="['sensitive_desc', {
            rules: [ { required: true, message: '请输入敏感词' } ]
          }]" placeholder="请输入敏感词"></a-input>
        </a-form-item>

        <a-form-item label="替换为" v-bind="$store.state.modal_ItemLayout">
          <a-input v-decorator="['replace_desc', {
            rules: [{ required: true, message: '请输入替换词' }]
          }]" placeholder="请输入替换词"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'sensitiveDict',
  data () {
    return {
      sensitiveId: false,
      visible: false,
      btnLoading: { loading: false },
      searchList: [
        { props: ['keywords'], placeholder: '敏感词', options: [], inputType: 'input' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        create_date: undefined
      },
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['neighbour:sensitiveDict:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['neighbour:sensitiveDict:delete'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.editSensitive(record), permi: ['neighbour:sensitiveDict:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record, record.community_name), permi: ['neighbour:sensitiveDict:delete'] }
      ],
      columns: [
        { title: '敏感词', dataIndex: 'sensitive_desc', align: 'left', width: '' },
        { title: '替换为', dataIndex: 'replace_desc', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/chat/sensitive',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addDict',
        addTitle: '新增敏感词'
      },
      deleteParam: {
        url: '/chat/sensitive',
        param: {pk_key: 'chat_sensitive_id', pk_val: ''},
        title: '敏感词',
        key: 'sensitive_desc'
      }
    };
  },
  beforeCreate () {
    this.modalForm = this.$form.createForm(this);
  },
  mounted () {
  },
  methods: {
    /** 点击修改敏感词 */
    editSensitive (record) {
      this.sensitiveId = record.chat_sensitive_id;
      this._get({
        url: `/chat/sensitive/${record.chat_sensitive_id}`,
        params: {}
      }).then(({data}) => {
        this.visible = true;
        this.$nextTick(() => {
          this.modalForm.setFieldsValue({
            sensitive_desc: data.sensitive_desc,
            replace_desc: data.replace_desc
          });
        });
      });
    },
    /** 提交修改敏感词 */
    handleSubmit () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return; }
        this._put({
          url: `/chat/sensitive/${this.sensitiveId}`,
          params: values,
          btnLoading: this.btnLoading
        }).then(({data}) => {
          this.visible = false;
          this.$message.success('修改成功');
          this.$refs.table.getTableList();
        });
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
